import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'popup-content, [popup-content], [popupContent], mir-popup-content, [mir-popup-content], [mirPopupContent]',
    standalone: false
})
export class PopupContentDirective {

  @HostBinding('class') hostCssClasses = 'mir-popup-content popup-content';

}
